import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useEmailRegistrationComplete } from "./hook";

export const EmailRegistrationCompletePage: React.FC = () => {
  const { handleEmailRegistrationComplete } = useEmailRegistrationComplete();

  return (
    <CardTemplate title="メール認証完了">
      <StyledTextContainer>
        メール認証が完了しました。続けて、ログインが簡単に行えるパスキー設定へお進みください。
      </StyledTextContainer>

      <Button
        text="次へ"
        variant="filled"
        onClick={handleEmailRegistrationComplete}
        fullWidth
      />
    </CardTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

